import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BrowserPageTitle } from '@shared/constants/browser-page-title.enum';

import { AchFormRetrievalPage } from './ach-form-retrieval.page';

const routes: Routes = [
  {
    path: '',
    component: AchFormRetrievalPage,
    data: { title: 'Autopay Setup Form Retrieval | US Foods' },
  },
];
// ag-todo: use browser page title enum

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AchFormRetrievalPageRoutingModule {}
